import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Container,
  KeyboardView,
  Wrapper,
  Title
} from "app/NativeComponents/common";
import {
  Header,
  NewHeader,
  SelectItem,
  SmallLabel,
  AttentionBox
} from "app/NativeComponents/snippets";

import Body from "./Body";

import {
  updateUser,
  popSidePanel,
  appRedirect,
  /*common functions*/
  dismissMobileKeyboard
} from "app/NativeActions";

class CreatePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        ...props.user,
        new_password: "",
        new_password_confirm: ""
      },
      loading: false
    };

    this.saveUserInfo = this.saveUserInfo.bind(this);
    this.checkIfNeedsToSave = this.checkIfNeedsToSave.bind(this);
    this.updateUserFieldChange = this.updateUserFieldChange.bind(this);
  }

  checkIfNeedsToSave() {
    if (
      this.state.user.new_password == this.state.user.new_password_confirm &&
      !!this.state.user.new_password &&
      !!this.state.user.new_password_confirm
    ) {
      return true;
    }

    return false;
  }

  updateUserFieldChange({ prop, value }) {
    this.setState({
      user: {
        ...this.state.user,
        [prop]: value
      }
    });
  }

  handleBack() {
    dismissMobileKeyboard();
    this.props.popSidePanel();
  }

  saveUserInfo() {
    /*mobile*/
    dismissMobileKeyboard();

    const { new_password, new_password_confirm } = this.state.user;
    this.props.updateUser({
      token: this.props.token,
      type: "create_password",
      payload: {
        new_password,
        new_password_confirm
      },
      onLoading: () => {
        this.setState({
          loading: true
        });
      },
      onError: () => {
        this.setState({
          loading: false
        });
      },
      onSuccess: results => {
        this.setState({
          loading: false
        });
        this.props.appRedirect({
          redirect: "init",
          payload: {
            token: this.props.token,
            user: results?.user,
            dealfinder_page: null,
            is_partner: 0,
            accepted_affiliate_latest_terms: 0
          }
        });
      }
    });
  }

  render() {
    return (
      <Container>
        {this.props.device == "mobile" ? (
          <NewHeader title="Create Password" />
        ) : (
          <Wrapper style={{ padding: 25 }}>
            <Title style={{ textAlign: "center" }}>Create Password</Title>
          </Wrapper>
        )}
        <KeyboardView style={{ flex: 1 }}>
          <AttentionBox
            description={
              "We need a password so you can log back in to your account."
            }
          />
          <Body
            {...this.props}
            editUser={this.state.user}
            loading={this.state.loading}
            saveUserInfo={this.saveUserInfo}
            checkIfNeedsToSave={this.checkIfNeedsToSave}
            updateUserFieldChange={this.updateUserFieldChange}
          />
        </KeyboardView>
      </Container>
    );
  }
}

const mapStateToProps = ({ auth, native, settings }) => {
  const { token, user } = auth;
  const { device } = native;
  const { colors } = settings;

  return { token, user, device, colors };
};

export default connect(mapStateToProps, {
  updateUser,
  appRedirect,
  popSidePanel
})(CreatePassword);
